import { createApiSlice } from "@common";
import { CRUD_SALES_TERRITORY, CRUD_SALES_TERRITORY_BY_ID } from "@routes";

const apiConfig = [
  {
    name: "addSalesTerritory",
    method: "post",
    url: CRUD_SALES_TERRITORY,
    stateKey: "message",
  },
  {
    name: "getSalesTerritoryById",
    method: "get",
    url: CRUD_SALES_TERRITORY_BY_ID,
    stateKey: "data",
  },
  {
    name: "updateSalesTerritory",
    method: "put",
    url: CRUD_SALES_TERRITORY,
    stateKey: "message",
  },
  {
    name: "deleteSalesTerritory",
    method: "delete",
    url: CRUD_SALES_TERRITORY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"salesTerritory", 
apiConfig, 
customReducers);
const salesTerritorySlice = slice;

export default salesTerritorySlice.reducer;

export const {
  addSalesTerritory,
  getSalesTerritoryById,
  updateSalesTerritory,
  deleteSalesTerritory,
} = thunks;

export const { rowSelect } = actions;
